import _ from 'lodash';
import Modal from '../../../../../_components/modal/modal.js';

import tpl from './add-player-to-group.tpl.html';
import './add-player-to-group.styles.less';

import AddPlayerView from './add-player/add-player.view.js';

class AddPlayerToGroupModal extends Modal {

	constructor (groupId, __players) {
		super(tpl, {
			title: 'Add Player to Group'
		}, {
			groupId: groupId,
			__players: __players
		});
	}

	uiElements() {
		return _.extend(super.uiElements(), {
			btnClose: '.btn-close',
			playersList: '.players-list'
		});
	}

	render(data) {
		super.render(data);

		this.options.__players.forEach( (__player, index) => {
			let addPlayerView = new AddPlayerView(
				__player.val(),
				{
					__player: __player,
					groupId: this.options.groupId
				}
			);
			addPlayerView.appendTo(this.ui.playersList);
		});

		this.ui.btnClose.click(() => this.close());
	}

	close(result) {
		this.ui.btnClose.off();

		super.close(result);
	}

}

export default AddPlayerToGroupModal;


// WEBPACK FOOTER //
// ./C:/Users/juanb/Dev/transforma-ping-pong-league/src/admin-section/groups/group/_modals/add-player-to-group-modal/add-player-to-group.modal.js